<template>
  <a
    :href="removeItemLink"
    class="d-inline-block quick-cart__remove-items"
    @click.prevent="removeItem"
  >
    <small>{{ removeText }}</small>
  </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      items: (state) => state.cart.items,
    }),

    removeItemLink() {
      return `${this.settings.cartChangeUrl}?line=${this.settings.productIndex}&amp;quantity=0`;
    },

    removeText() {
      return window.theme.strings.cart.general.remove;
    },
  },

  methods: {
    removeItem() {
      const itemToRemove = this.items[this.settings.productIndex - 1];

      // eslint-disable-next-line no-undef
      datalayerRemoveItem(itemToRemove);
      document.location.href = this.removeItemLink;
    }
  },
}
</script>

<style>

</style>